module.exports = __webpack_public_path__ + "img/dhl.8af70785.svg";